/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type PensionSavingDetailFundType = (typeof PensionSavingDetailFundType)[keyof typeof PensionSavingDetailFundType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PensionSavingDetailFundType = {
  dps: "dps",
  transformed_fund: "transformed_fund",
} as const;
